import { render, staticRenderFns } from "./AlipayAuthCallback.vue?vue&type=template&id=1bba66c2&scoped=true"
import script from "./AlipayAuthCallback.vue?vue&type=script&lang=js"
export * from "./AlipayAuthCallback.vue?vue&type=script&lang=js"
import style0 from "./AlipayAuthCallback.vue?vue&type=style&index=0&id=1bba66c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bba66c2",
  null
  
)

export default component.exports